/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const NotificationType = {
    NFT_PROMO: 'NFT_PROMO',
    PROMO_TOKEN: 'PROMO_TOKEN',
    SPONSORED_COMPETITION_WINNER: 'SPONSORED_COMPETITION_WINNER',
    OVERWOLF_XP_FUEL_REWARD: 'OVERWOLF_XP_FUEL_REWARD',
    PRIZE_POOL: 'PRIZE_POOL',
    MERCH_FULFILLMENT: 'MERCH_FULFILLMENT'
} as const;
export type NotificationType = typeof NotificationType[keyof typeof NotificationType];


export function instanceOfNotificationType(value: any): boolean {
    for (const key in NotificationType) {
        if (Object.prototype.hasOwnProperty.call(NotificationType, key)) {
            if (NotificationType[key as keyof typeof NotificationType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function NotificationTypeFromJSON(json: any): NotificationType {
    return NotificationTypeFromJSONTyped(json, false);
}

export function NotificationTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationType {
    return json as NotificationType;
}

export function NotificationTypeToJSON(value?: NotificationType | null): any {
    return value as any;
}

export function NotificationTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): NotificationType {
    return value as NotificationType;
}

